import { useEffect, useState } from "react";
import axios from "../../api/adminAxios";
import AdminSidebar from "./AdminSidebar";

interface ResetLog {
    id: number;
    restaurant_name: string;
    reset_date: string;
    previous_count: number;
    reason: string;
}

export default function AdminChatResetLogs() {
    const [logs, setLogs] = useState<ResetLog[]>([]);

    useEffect(() => {
        axios.get<ResetLog[]>("/admin/chat-limit/resets").then((res) => {
            setLogs(res.data);
        });
    }, []);

    return (
        <div className="min-h-screen flex bg-gray-100">
            <AdminSidebar />
            <div className="flex-1 p-6">
                <h2 className="text-2xl font-bold mb-4">📅 Chat Reset History</h2>
                <div className="bg-white rounded shadow p-4 overflow-auto">
                    {logs.length === 0 ? (
                        <p className="text-gray-500">No reset history found.</p>
                    ) : (
                        <table className="w-full text-sm table-auto border">
                            <thead className="bg-gray-100">
                            <tr>
                                <th className="p-2 border">Restaurant</th>
                                <th className="p-2 border">Reset Date</th>
                                <th className="p-2 border">Previous Count</th>
                                <th className="p-2 border">Reason</th>
                            </tr>
                            </thead>
                            <tbody>
                            {logs.map((log) => (
                                <tr key={log.id} className="text-center">
                                    <td className="p-2 border">{log.restaurant_name}</td>
                                    <td className="p-2 border">{new Date(log.reset_date).toLocaleString()}</td>
                                    <td className="p-2 border">{log.previous_count}</td>
                                    <td className="p-2 border">{log.reason}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
